export const tagPrice = 4;
export const currency = {
    name: 'euro',
    char: '€',
    unit: 'eur',
}
export const buildingProperties = ['name', 'address', 'postalCode', 'city', 'country']